import './implementation.scss'

const SCOPE_POINTS = [
  'Organizations adopting leadership.net standards may require limited implementation support to ensure correct application.',
  'This support exists solely to protect the integrity of the standards.',
  'Support is bounded, time-limited, and focused on correct application — not outcomes.'
]

const EXCLUSIONS = [
  'It is not advisory work.',
  'It is not customization.',
  'It does not replace leadership accountability.',
  'Implementation support does not include facilitation, coaching, or decision-making on behalf of leaders.'
]

const ImplementationPage = () => (
  <div className="implementation-page">
    <main className="implementation">
      <header className="implementation__hero" aria-label="Implementation Support">
        <div className="implementation__rail">
          <span className="implementation__index">06</span>
          <span className="implementation__label">Implementation Support</span>
        </div>

        <h1>Implementation Support</h1>
      </header>

      <section className="implementation__grid" aria-label="Implementation Support content">
        <article className="implementation__panel" aria-label="Scope">
          <header className="implementation__panel-head">
            <span className="implementation__panel-index">1</span>
            <h2>Scope</h2>
          </header>

          <ol>
            {SCOPE_POINTS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </article>

        <article className="implementation__panel" aria-label="Not included">
          <header className="implementation__panel-head">
            <span className="implementation__panel-index">2</span>
            <h2>Not included</h2>
          </header>

          <ol>
            {EXCLUSIONS.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </article>
      </section>

      <a className="implementation__back" href="/">
        ← Back to leadership.NET
      </a>
    </main>
  </div>
)

export default ImplementationPage
